<template>
  <div class="container">
    <Header></Header>
    <Banners :banner="banner"></Banners>
    <Introduce :Introduce="company_introduction"></Introduce>
    <Introduce :Introduce="big_data_team_strength"></Introduce>
    <CorporateCulture></CorporateCulture>

    <Footer></Footer>
  </div>
</template>

<script>
  import Header from "@/components/Header"
  import Footer from "@/components/Footer"
  import Banners from "@/components/Banners"
  import Introduce from "@/components/About_Us/Introduce"
  import CorporateCulture from "@/components/About_Us/CorporateCulture"

  export default {
    name: 'About_Us',
    data() {
      return {
        banner: require("@/assets/imgs/bg-banner-aboutus.png"),
        company_introduction: {
          title: "公司简介",
          contents:
            [],
          class: "FFFFFF"
        },
        big_data_team_strength: {
          title: "团队实力",
          contents: ['公司管理人员来自于知名品牌企业，拥有科技、法律、管理等领域深厚的专业知识背景和丰富的从业经验，能够为行业客户提供优质的数据解决方案。',"公司技术团队主要由数据技术、数据产品、算法挖掘、运营平台团队组成，目前约有40多位优秀的技术工程师加入，其中团队核心成员均达到十年以上基础数据研究经验，专注于大数据算法、数据模型及网络通信技术研究，专注于行业数据增值业务的探索与实践，致力于成为行业最佳数据解决方案供应商，让数据更智慧。"],
          class: "F4F4F4"
        }
      }
    },
    components: {
      Header, Banners,Footer,Introduce,CorporateCulture
    },
    created() {
      this.$store.commit('changeNavs', 'About_Us')
    },
    mounted() {
      this.company_introduction.contents = [
        "江苏道泰信息技术有限公司（" +
        this.website +
        "）成立于2021年7月，是一家专注于移动互联网商务服务领域，致力于为客户提供专业的数据资源整合、应用、开发和运营等方案与服务的高新技术企业，拥有高效的数据应用与服务平台的建设能力，支持客户在数据挖掘、数据整理、数据分析、精准营销、跨领域数据融合、供应链重组与整合等场景获得深度赋能。","公司作为一家数据科技企业，在保险金融领域的精准数据分析与挖掘方面拥有丰富的资源与技术积累，当前服务的客户主要包括众安保险经纪、爱邦保险经纪、保通保险代理等保险机构。","公司致力于为金融行业、公共事业等领域提供有竞争力的数据解决方案，不断提升客户体验，为客户创造最大价值，开启数据赋能的智慧科技新时代。"
      ]
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .container {
    min-width: 1350px;
  }
</style>



// WEBPACK FOOTER //
// src/views/About_Us.vue